import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aff-linked-icon',
  templateUrl: './linked-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LinkedIconComponent {}
